import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskProdGantt';

const taskProdGanttService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  getProductions: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productions`,
      data,
    });
  },

  getMachines: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/machines`,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  updateProduction: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/production`,
      data,
    });
  },

  getActiveTimeByRange: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/activeTimes`,
      data,
    });
  },

  getProductionsForStore: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/prodForStore`,
      data,
    });
  },

  getUnstartedOperations: (data) => request({ method: Methods.POST, resource: `${baseURL}/unstartedOperations`, data }),

  scheduleOperationFromStore: (data) => request({ method: Methods.PUT, resource: `${baseURL}/operationFromStore`, data }),

  updateProductionFromStore: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/production/prodStore`,
      data,
    });
  },
};
export default taskProdGanttService;
